<template>
<div class="chapter">
<div class="inner_page">
<p class="cn-only" id="ch5"><span class="epub-b">5</span></p>
<p class="co">My mom always made me sit outside on the stairs when Maeve and Gracie were having their weekly bath, so my knowledge of the opposite sex was somewhat limited. I consequently relied on Sammy’s experience and my own research at the Mansion on Jackson Street near Kearny. I know that ‘The Mansion’ sounds fancy, but actually it was the crummiest and biggest brothel in San Francisco. This guy McCarthy had got elected as mayor on a promise of making San Francisco ‘the Paris of America’, and the first thing he did when he took office was to take graft from a guy called Gerry McGlane, who was allowed to open a ‘Parisian’ brothel.</p>
<p class="tx">Inside there were over a hundred tiny curtained-off cubicles where for a couple of dollars guys could take their pleasures with a South American beauty or, for a dollar more, they could get a genuine ‘Frenchie’ all the way from Paris or Warsaw or some place not around here. Not that Sammy and I were very much involved. The girls liked us and we would pour their drinks, and if it was a slow night they would show us a thing or two.</p>
<p class="tx">As fate would have it, I was there with Sammy the night the police raided the place. When the cops saw so many spotty kids getting their two dollars-worth, they immediately closed the place down and made us all line up outside in the freezing cold. We stood there, ten skinny kids, shivering on Jackson Street with nothing but our underpants and a skin full of goose bumps between us and pneumonia.</p>
<p class="tx">‘My mom will kill me,’ I said.</p>
<p class="tx">‘Forget it. Your mom won’t know,’ said Sammy. He was freezing too, but he was completely unafraid.</p>
<p class="tx">‘But they’re taking our names.’</p>
<p class="tx">‘Don’t worry, they’re bluffing.’</p>
<p class="tx">‘They look serious to me. What makes you so sure?’</p>
<p class="tx">The cops were taking their time getting to us as they took the details of each of the kids standing there in the street catching their deaths.</p>
<p class="tx">‘My uncle says these cops have had more grease than the Van Ness streetcar wheels. And you know what happened to Police Chief Biggy.’</p>
<p class="tx">‘No. What happened?’</p>
<p class="tx">‘Big Bill closed down the Municipal brothel a few years back and…’</p>
<p class="tx">Sammy shook his head as if that was sufficient to finish his sentence. We both clutched ourselves, trembling from the cold. But I wanted to know more.</p>
<p class="tx">‘What?’</p>
<p class="tx">‘He mysteriously disappeared.’ Sammy’s lips were now blue and his teeth were chattering. ‘From his police launch. They fished him out of the bay the next day.’</p>
<p class="tx">‘Murdered?’</p>
<p class="tx">‘No one knows.’</p>
<p class="tx">‘S-s-suicide?’ I chattered. I was now beyond cold and had a problem putting my words together. Sammy shook his head, no.</p>
<p class="tx">‘Strict Catholic.’</p>
<p class="tx">‘How about the guy piloting the boat? Didn’t he see anything?’</p>
<p class="tx">‘Amnesia.’</p>
<p class="tx">‘Amnesia?’</p>
<p class="tx">‘Couldn’t remember a thing. My Uncle Joe said the rumor was that when they fished Biggy out of the water he’d had his dick chopped off – they found it in his coat pocket with his watch. That’s enough to give anyone amnesia.’</p>
<p class="tx">Sure enough, the cops took down our particulars and told us all to scram. We grabbed our clothes and ran home splashing through the puddles, shivering and laughing in the rain.</p>
<p class="tx">Two days later, the Mansion was open for business again.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?c780d9ee